module.exports = __webpack_public_path__ + "static/media/timeline3.619c348c.jpg";